import axios from './axios';

const fetchAvailableDocumentOfTruthTypes = () => {
  return axios
    .get<TAvailableDocumentOfTruthTypes>('/gw/billing/v1.0/billing/available-document-of-truth-types')
    .then(res => res.data);
};

export { fetchAvailableDocumentOfTruthTypes };

export type TAvailableDocumentOfTruthTypes = {
  firmId: number;
  hasDataMatchPoint: boolean;
  availableDocumentOfTruthTypes: Array<{
    id: number;
    name: string;
  }>;
};
